import React from 'react'

export const FileIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask id={maskId} fill='white'>
        <path d='M13 5L17 9V18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18V6C7 5.44772 7.44772 5 8 5H13Z' />
      </mask>
      <path
        d='M13 5L13.7071 4.29289L13.4142 4H13V5ZM17 9H18V8.58579L17.7071 8.29289L17 9ZM17 18H18H17ZM16 19V20V19ZM8 19L8 20H8V19ZM7 18H6H7ZM7 6L6 6V6H7ZM8 5V4V5ZM13 5L12.2929 5.70711L16.2929 9.70711L17 9L17.7071 8.29289L13.7071 4.29289L13 5ZM17 9H16V18H17H18V9H17ZM17 18H16V19V20C17.1046 20 18 19.1046 18 18H17ZM16 19V18H8V19V20H16V19ZM8 19L8 18H8H7H6C6 19.1046 6.89543 20 8 20L8 19ZM7 18H8V6H7H6V18H7ZM7 6L8 6V6V5V4C6.89543 4 6 4.89543 6 6L7 6ZM8 5V6H13V5V4H8V5Z'
        fill='currentColor'
        mask={`url(#${maskId})`}
      />
      <path
        d='M12.5 5.5V9.5H16.5'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
